module.exports = __webpack_public_path__ + "static/media/audit.e948bef6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/audit.svg
// module id = 155
// module chunks = 0